import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

export default function HeadingPermissionDialog({ open, onApprove, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} disableBackdropClick>
      <DialogTitle>方位の取得について</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">
          進行方向を地図に表示するため、端末のコンパス（デバイスの向き）を利用します。
          iOSでは「許可」をタップするとシステムの確認が表示されます。
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>今はしない</Button>
        <Button color="primary" variant="contained" onClick={onApprove}>
          許可して有効化
        </Button>
      </DialogActions>
    </Dialog>
  );
}
